import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../shared/modals';
import { useStore } from '../../../shared/store';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { Table } from '../../../elements/table';
import { PageBody } from '../../../elements/page-body';
import { RenderFilters } from '../../../elements/render-filters/render-filters';
import { useHttpClient } from '../../../shared/http-client';
import { RoutesFilter } from './routes.filter';
//import { TripsFilter } from './trips-filter';

export const RoutesComponents = () => {
    const { t } = useTranslation();
    const { open, close } = useModal();
    const navigate = useNavigate();
    const { open: openDrawer, close: closeDrawer } = useDrawer();
    const { api, state } = useHttpClient();
    const { get, set } = useStore();

    const filtrosGuardados = get('trips') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [drivers, setDrivers] = useState<any[]>([]);

    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        openDrawer('common.filter.title', <RoutesFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const doFilter = (filters: any) => {
        set('trips', filters);
        setFilters(filters);
        setQuery(new URLSearchParams(filters));
        setRefresh(Date.now().toString());
        closeDrawer();
    };

    const showRoute = (item: any) => {
        navigate(`/routes/${item.id}`);
    };

    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
                api('/fleet/drivers/', 'GET');
            }
        }
        if (state.data && state.path.includes('drivers')) {
            if (Array.isArray(state.data.results)) {
                setDrivers(state.data.results);
            }
        }
    }, [state]);

    return (
        <PageBody title={'common.label.rutas'} filterAction={handleFilters} filters={filters}>
            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} />
                ) : (
                    ''
                )}

                <Table
                    path="/fleet/routes/"
                    deletePath="/fleet/routes/"
                    callBeforeDrawerClosed={handleClose}
                    withPagination
                    noEdit
                    onShow={showRoute}
                    query={query}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'date',
                            type:"datetime",
                            label: 'common.labels.date'
                        },
                        {
                            key: 'code',
                            label: 'common.label.codigo'
                        },
                        {
                            key: 'area',
                            label: 'common.label.area'
                        },
                        {
                            key: 'driver',
                            label: 'common.label.comercial'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};
